<template>
  <div id="sp_user" style="background: #FFF;height: 100%;overflow: auto;">
    <mt-header :title="$t('个人主页')" class="dl_header_white" fixed style="margin-bottom: 13px;">
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
      <!--      <mt-button slot="right" @click="goback">-->
      <!--        <img src="@/assets/img/zhuanfa.png" alt="" style="width: 20px;height: 20px;">-->
      <!--      </mt-button>-->
    </mt-header>
    <!--     间隔 -->
    <div class="" style="height: 25px;background: #fff;"></div>
    <!-- 头像 -->
    <div class="avatar_box"
         style="height: 100px;position: relative;background: #fff;margin-top: 26px;box-shadow: 10px 5px 15px rgb(249,249,249);">
      <img class="head avatar" v-if="userinfo.avatar" :src="userinfo.avatar"
           style="width: 54px;height: 54px;margin-left: 30px;margin-top: 5px;"/>
      <img class="head avatar" v-else src="@/assets/img/avatar.jpg"
           style="width: 54px;height: 54px;margin-left: 30px;margin-top: 5px;"/>
      <img v-show="userinfo.v_status" class="head v_status" src="@/assets/img/touming.png"
           style="width: 25px;height: 25px;position: absolute; left: 60px; top: 38px;"/>
      <div class="author-fr">
        <span v-if="userinfo.user_nickname" class="user_nickname"
              style="">{{ userinfo.user_nickname }}</span>

        <span v-else class="user_nickname" style="">{{ $t("匿名用户") }}</span>
        <span class="v_title">{{ userinfo.v_title }}</span>
        <span v-if="userinfo.signature&&userinfo.signature.length<16" class="signature">{{ userinfo.signature }}</span>
        <span v-else-if="userinfo.signature&&userinfo.signature.length>15"  class="signature">{{userinfo.signature.replace(userinfo.signature.substr(15), '...') }}</span>
        <span v-else class="signature">{{ $t("暂无签名") }}</span>
      </div>
<!--      <div class="guanzhu">-->
<!--        <img v-show="userinfo.id != loginUser.id" src="@/assets/img/juxing5.png" alt=""-->
<!--             style="width: 90px;height:40px;right: 12px;bottom: 9px">-->

        <a v-show="userinfo.id != loginUser.id" v-if="userinfo.is_follow" href="javascript:;" class="guan" @click="follow(0)"
           style="">{{ $t("已关注") }}</a>
        <a v-show="userinfo.id != loginUser.id" v-else-if="userinfo.id != loginUser.id" href="javascript:;" class="guan" @click="follow(1)"
           style="">{{ $t("关注") }}</a>
<!--      </div>-->

    </div>

    <div class="AllTrend" :style="style">
      <pull-to
          :top-load-method="refresh"
          @top-state-change="topStateChange"
          :bottom-load-method="loadmore"
          @bottom-state-change="bottomStateChange"
          :top-block-height="10"
          :bottom-block-height="10"
          style="font-size: 14px;color: #aaa;"
      >

        <trend-content :allTrend="allTrend" :refreshUrl="refreshData"></trend-content>
        <div v-show="loading"><img src="@/assets/img/loading.gif" style="margin: 30px auto;"></div>
        <div v-show="nomore" style="margin: 0 auto 20px;text-align: center;color: #aaa;font-size: 14px;">
          {{ $t("没有更多了") }}
        </div>
        <div v-show="nodata" style="margin: 80px 70px; width: 40%;">
          <img src="@/assets/img/nodata.png">

          <span style="color: #aaa;margin-left: 70px;font-size: 14px;">{{ $t("暂无数据") }}</span>
        </div>
      </pull-to>
    </div>

  </div>
</template>

<script>
import PullTo from 'vue-pull-to'
import {delMoment, followUser, unfollowUser, getMoment, getUserinfoById, likeOrNotLike} from "../../api/trend";
import {MessageBox, Toast} from "mint-ui";

export default {
  name: "TrendMine",
  data() {
    return {
      userid: 0,
      limit_num: 20,
      limit_begin: 0,
      type: 1,
      alllist: false,
      allTrend: [],
      nodata: false,
      nomore: false,
      loading: false,

      userinfo: {},

      loginUser: {},
      style: {},
      refreshData: {
        limit_begin: 0,
        limit_num: 20,
        type: 1
      },
    }
  },
  components: {
    PullTo
  },
  created() {
    this.currentHeight()
  },
  mounted() {
    this.nomore = false;
    this.nodata = false;
  },
  activated() {
    this.userid = this.$route.query.id
    this.loginUser = this.$store.state.userInfo
    this.getAllTrend({
      limit_begin: 0,
      limit_num: 20,
      type: this.type,
      user_id: this.userid
    })
    this.get_userinfoById({
      uid: this.userid
    })
  },
  methods: {
    goback: function () {
      this.$router.back();
    },
    get_userinfoById(data) {
      getUserinfoById(data)
          .then(res => {
            this.userinfo = res.data
          }).catch(error => {
        console.log(error)
      })
    },
    getAllTrend(data) {
      getMoment(data)
          .then(res => {
            if (res.data.count == 0) {
              this.nodata = true;
            } else {
              this.alllist = true;
              this.allTrend = res.data.list
              this.limit_begin = data.limit_begin + res.data.count
            }
          }).catch(error => {
        console.log(error)
      })
    },


    follow(type) {
      if (type == 0) {
        //  取消关注
        unfollowUser({
          user_id: this.userinfo.id
        }).then(res => {

          MessageBox.alert(res.msg, this.$t("提示"))
          this.userinfo.is_follow = 0
        })
      } else {
        //  关注
        followUser({
          user_id: this.userinfo.id
        }).then(res => {

          MessageBox.alert(res.msg, this.$t("提示"))
          this.userinfo.is_follow = 1
        })
      }
    },
    refresh(loaded) {
      getMoment({
        limit_begin: 0,
        limit_num: 20,
        type: this.type,
        user_id: this.userid
      })
          .then((res) => {
            this.allTrend = res.data.list
            this.limit_begin = res.data.count
            loaded('done')
          })
    },
    topStateChange(state) {
      if (state === 'pull' || state === 'trigger') {
        this.iconLink = '#icon-arrow-bottom';
      } else if (state === 'loading') {
        this.iconLink = '#icon-loading';
      } else if (state === 'loaded-done') {
        this.iconLink = '#icon-finish';
      }
    },
    loadmore(loaded) {
      getMoment({
        limit_begin: this.limit_begin,
        limit_num: this.limit_num,
        type: this.type,
        user_id: this.userid
      }).then(res => {
        if (res.data && res.data.count == 0) {
          this.nomore = true
        } else {
          this.nomore = false
          this.allTrend = this.allTrend.concat(res.data.list);
          this.limit_begin = this.limit_begin + res.data.count
        }
        loaded('done');
      })
    },
    bottomStateChange(state) {
      if (state === 'pull' || state === 'trigger') {
        this.iconLink = '#icon-arrow-bottom';
      } else if (state === 'loading') {
        this.iconLink = '#icon-loading';
      } else if (state === 'loaded-done') {
        this.iconLink = '#icon-finish';
      }
    },
    currentHeight() {
      this.style.height = window.innerHeight - 100 + 'px'
    }
  }
}
</script>

<style scoped>
.avatar_box * {
  position: absolute;
}

.avatar_box .avatar {
  width: 60px;
  height: 60px;
  /*left: 20px;*/
  border-radius: 50%;
}

.avatar_box .user_nickname {
  width: 200px;
  font-size: 16px;
  top: 5px;
  left: 100px;
  line-height: 14px;
}

.avatar_box .v_title {
  width: 400px;
  font-size: 16px;
  left: 0;
  top: 26px;
  line-height: 16px;
  transform: scale(0.5);
}

.avatar_box .signature {
  width: 400px;
  font-size: 12px;
  left: 100px;
  top: 25px;
  color: #666;
  line-height: 16px;
}
.guan{
  min-width:70px;
  right: 20px;
  bottom: 10px;
  text-align: center;
  color: #fff;
  font-weight: 600;
  background: #1C74F2;
  border-radius:18px 0px 18px 0px;
  padding: 5px 7px 10px;
}
</style>
